module.exports = __webpack_public_path__ + "static/media/logo.5ede78f8.svg";